/*
 * Copyright 2026 North Carolina State University
 */

/**
 * IPM (Integrated Pest Management) — admin window.
 *
 * An optional module: nothing in the core imports from this folder except the
 * route and menu link, both behind ModuleGate. Uses the core's left-pane
 * layout styles so it looks like Accounting and Manage Program Data.
 */

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/ManageProgramData.css';
import './ipm.css';
import IpmSummary from './pages/IpmSummary';
import IpmDataEntry from './pages/IpmDataEntry';
import IpmControls from './pages/IpmControls';

const SECTIONS = [
  { key: 'summary', label: 'Summary', Component: IpmSummary },
  { key: 'data-entry', label: 'Data Entry', Component: IpmDataEntry },
  { key: 'controls', label: 'List of Controls', Component: IpmControls },
];

const isSection = (key) => SECTIONS.some(s => s.key === key);

const IpmModule = () => {
  const location = useLocation();
  // Deep-linkable as /admin/ipm?section=data-entry
  const sectionFromUrl = new URLSearchParams(location.search).get('section');
  const [activeSection, setActiveSection] = useState(
    isSection(sectionFromUrl) ? sectionFromUrl : 'summary'
  );

  useEffect(() => {
    if (isSection(sectionFromUrl)) setActiveSection(sectionFromUrl);
  }, [sectionFromUrl]);

  const { Component } = SECTIONS.find(s => s.key === activeSection) || SECTIONS[0];

  return (
    <div className="manage-program-container">
      <div className="sidebar">
        <h2>IPM <span className="ipm-beta-badge">Beta</span></h2>
        <ul>
          {SECTIONS.map(({ key, label }) => (
            <li key={key}>
              <button
                type="button"
                className={activeSection === key ? 'active' : ''}
                aria-current={activeSection === key ? 'page' : undefined}
                onClick={() => setActiveSection(key)}
              >{label}</button>
            </li>
          ))}
        </ul>
      </div>
      <div className="content-area">
        <Component onNavigate={setActiveSection} />
      </div>
    </div>
  );
};

export default IpmModule;
